var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon",on:{"click":_vm.onClick}},[_c('div',{staticClass:"icon__top"}),_c('div',{staticClass:"icon__bottom"})])
}
var staticRenderFns = []

export { render, staticRenderFns }